import { TextField } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { PropTypes } from "prop-types";

export function RHFSelect({
  name,
  native,
  maxHeight = 220,
  helperText,
  children,
  defaultValue,
  PaperPropsSx,
  method,
  required,
  disabled,
  placeholder,
  ...other
}) {
  return (
    <Controller
      name={name}
      control={method}
      defaultValue={defaultValue}
      render={({ field, fieldState: { error } }) => (
        <TextField
        disabled={disabled}
          size="small"
          {...field}
          select
          fullWidth
          placeholder={placeholder}
          SelectProps={{
            native,
            MenuProps: {
              PaperProps: {
                sx: {
                  ...(!native && {
                    maxHeight:
                      typeof maxHeight === "number" ? maxHeight : "unset",
                  }),
                  ...PaperPropsSx,
                },
              },
            },
            sx: { textTransform: "capitalize" },
          }}
          required={required}
          error={!!error}
          helperText={error ? error?.message : helperText}
          {...other}
        >
          {children}
        </TextField>
      )}
    />
  );
}
RHFSelect.propTypes = {
  PaperPropsSx: PropTypes.object,
  children: PropTypes.node,
  helperText: PropTypes.object,
  maxHeight: PropTypes.number,
  name: PropTypes.string,
  method: PropTypes.object.isRequired,
  native: PropTypes.bool,
};
